module.exports = __webpack_public_path__ + "static/media/salary.72733441.svg";